// generic component for displaying a label and data within a card
import React, { HTMLAttributes } from "react"
import classNames from "classnames";
import { ThemedSpan } from "../../../components/utilities";

export type WidgetDataLabelProps = HTMLAttributes<HTMLDivElement> & {
    centerValue: any | null
    centerValueVariant?: ThemeVariant
    includeCenter?: boolean
    isLabelBold?: boolean
    label: string
    labelVariant?: ThemeVariant
    value: any | null
    valueVariant?: ThemeVariant
}

const WidgetDataLabel = React.forwardRef<HTMLDivElement, WidgetDataLabelProps>(({ 
    centerValue = null,
    centerValueVariant = 'primary',
    className,
    includeCenter = false,
    isLabelBold = false,
    label, 
    labelVariant = 'primary', 
    value = null, 
    valueVariant = 'primary',
    ...rest
} : Readonly<WidgetDataLabelProps>, ref) => (
    <div ref={ref} className={classNames("col-12", className)} {...rest}>
        <div className="row">
            <div className={classNames("col-6", { 'fw-bold': isLabelBold })}>
                <ThemedSpan variant={labelVariant}>{label}</ThemedSpan>
            </div>
            {includeCenter === true && (
                <div className="col-3 text-center fw-bold">
                    <ThemedSpan variant={centerValueVariant}>{centerValue ? centerValue : (<span>-</span>)}</ThemedSpan>
                </div>
            )}
            <div className={classNames("text-end fw-bold", { 'col-3': includeCenter === true, 'col-6': includeCenter === false })}>
                <ThemedSpan variant={valueVariant}>{value ? value : (<span>-</span>)}</ThemedSpan>
            </div>
        </div>
    </div>
));

export default WidgetDataLabel;